<script>
    import { goToURL } from "../../../Utils/utilFunctions.svelte";

    export let label;
    export let value;
    export let error;
    export let inputClass = "";
    export let clearError = () => {};
    export let isAutoComplete = "on";

    export let showForgotPwd = false;

    let showPassword = false;

    $: usernameClass = error
        ? "rounded border border-[#E05757] text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out "
        : "rounded border border-gray-300 focus:border-gray-500 focus:ring-1 focus:ring-gray-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out ";

    $: passwordClass = error
        ? "rounded border border-[#E05757] text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out "
        : "rounded border border-gray-300 focus:border-gray-500 focus:ring-1 focus:ring-gray-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out ";

    const keepShowPasswordStatus = () => {
        let el = document.getElementById(`${label}`);
        if (showPassword) el.type = "text";
        else el.type = "password";
    };

    const toggleShowPassword = () => {
        showPassword = !showPassword;
        keepShowPasswordStatus();
    };

    const goToForgotPassword = () => {
        goToURL("/forget-password");
    };
</script>

<div class="flex flex-col mb-4">
    <div class="flex flex-1 justify-between">
        <label
            for={label}
            class="leading-7 text-sm text-gray-600 font-bold text-[14px] mb-2"
        >
            {label}
        </label>

        {#if showForgotPwd}
            <p
                class="leading-7 text-sm text-gray-600 font-bold text-[14px] mb-2 cursor-pointer"
                on:click|preventDefault={goToForgotPassword}
            >
                Forgot Password?
            </p>
        {/if}
    </div>

    {#if label.toLowerCase().includes("password")}
        <div class="relative">
            <input
                bind:value
                id={label}
                name={label}
                type="password"
                {...$$restProps}
                class={passwordClass + inputClass}
                on:input={keepShowPasswordStatus}
                on:click={clearError}
                required
                autocomplete={isAutoComplete}
            />
            {#if showPassword}
                <i
                    style="font-size:16px"
                    class="fa absolute top-1/3 right-4 hover:cursor-pointer"
                    on:click|preventDefault={toggleShowPassword}>&#xf070;</i
                >
            {:else}
                <i
                    style="font-size:16px"
                    class="fa absolute top-1/3 right-4 hover:cursor-pointer"
                    on:click|preventDefault={toggleShowPassword}>&#xf06e;</i
                >
            {/if}
        </div>
    {:else}
        <input
            bind:value
            id={label}
            name={label}
            {...$$restProps}
            class={usernameClass + inputClass}
            on:click={clearError}
            required
            autocomplete={isAutoComplete}
        />
    {/if}
</div>
